import {City} from '../../../../components/TariffsMap/components/City'
import type {ClusterFeature} from '../../../../components/TariffsMap/types'

export const marker = ({geometry, properties}: ClusterFeature) => (
  <City coordinates={geometry.coordinates} onClick={properties?.onPointClick} value={properties.title || ''} />
)
